const toApiOrigin = () => {
  const backendOrigin = String(import.meta.env.VITE_BACKEND_ORIGIN || "").trim();
  if (backendOrigin) {
    return backendOrigin.replace(/\/$/, "");
  }

  const apiBase = String(import.meta.env.VITE_API_BASE_URL || "").trim();
  if (!apiBase) {
    return "";
  }

  if (apiBase.startsWith("http://") || apiBase.startsWith("https://")) {
    try {
      return new URL(apiBase).origin;
    } catch {
      return "";
    }
  }

  return "";
};

const API_ORIGIN = toApiOrigin();

const stripWrappingQuotes = (value: string) => {
  if (
    (value.startsWith('"') && value.endsWith('"')) ||
    (value.startsWith("'") && value.endsWith("'"))
  ) {
    return value.slice(1, -1);
  }

  return value;
};

const isHttpUrl = (value: string) => {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const normalizeDataUrl = (value: string) => {
  const compact = value.replace(/\s+/g, "");
  if (!compact.startsWith("data:")) {
    return "";
  }

  const commaIndex = compact.indexOf(",");
  if (commaIndex <= 5 || commaIndex === compact.length - 1) {
    return "";
  }

  const header = compact.slice(0, commaIndex).toLowerCase();
  const payload = compact.slice(commaIndex + 1);

  if (header.includes(";base64") && !/^[A-Za-z0-9+/]+=*$/.test(payload)) {
    return "";
  }

  return compact;
};

export const resolveMediaUrl = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  const url = stripWrappingQuotes(raw);
  if (!url) {
    return "";
  }

  if (isHttpUrl(url)) {
    return url;
  }

  if (url.startsWith("data:")) {
    return normalizeDataUrl(url);
  }

  if (url.startsWith("blob:")) {
    return url;
  }

  if (url.startsWith("/uploads/")) {
    return API_ORIGIN ? `${API_ORIGIN}${url}` : url;
  }

  if (url.startsWith("uploads/")) {
    return API_ORIGIN ? `${API_ORIGIN}/${url}` : `/${url}`;
  }

  return url;
};
